import React from 'react';
import { Button, Row } from 'antd';
import { Link, useParams } from 'react-router-dom';
import CostOrderForm from './CostOrderForm';
import CostClaimList from './CostClaimList';

const CostClaim = () => {
  const { proceedingId } = useParams<any>();
  return (
    <>
      <Row>
        <CostOrderForm proceedingId={proceedingId} />
      </Row>
      <Row>
        <CostClaimList />
      </Row>
    </>
  );
};

export default CostClaim;
